import { render, staticRenderFns } from "./DetailPumkm.vue?vue&type=template&id=1f4335b7&"
import script from "./DetailPumkm.vue?vue&type=script&lang=js&"
export * from "./DetailPumkm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports